'use client';
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

const integrations = [
  { id: 'int-openai', name: 'OpenAI', label: 'GPT-4o', statusKey: 'active', color: 'text-mint', bg: 'bg-mint/10' },
  { id: 'int-google', name: 'Google AI', label: 'Gemini', statusKey: 'active', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'int-anthropic', name: 'Anthropic', label: 'Claude', statusKey: 'active', color: 'text-secondary-foreground', bg: 'bg-secondary' },
  { id: 'int-runway', name: 'Runway', label: 'Video AI', statusKey: 'comingSoon', color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'int-elevenlabs', name: 'ElevenLabs', label: 'Voice AI', statusKey: 'comingSoon', color: 'text-primary', bg: 'bg-primary/10' },
  { id: 'int-heygen', name: 'HeyGen', label: 'Avatars', statusKey: 'comingSoon', color: 'text-mint', bg: 'bg-mint/10' },
  { id: 'int-pika', name: 'Pika', label: 'Animation', statusKey: 'planned', color: 'text-accent', bg: 'bg-accent/10' },
  { id: 'int-stability', name: 'Stability AI', label: 'Images', statusKey: 'planned', color: 'text-secondary-foreground', bg: 'bg-secondary' },
];

export default function IntegrationsSection() {
  const { t } = useLanguage();
  const ig = t?.integrationsSection;

  return (
    <section className="py-24 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16">
        <div className="text-center mb-14">
          <p className="text-xs font-600 uppercase tracking-widest text-accent mb-3">
            {ig?.sectionLabel ?? 'Powered By'}
          </p>
          <h2 className="text-hero-md font-700 text-foreground mb-4">
            {ig?.sectionTitle ?? 'The Best AI Models, Unified'}
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-base">
            {ig?.sectionSubtitle ?? "AIMaker Studio connects to the world's leading AI providers — so you always have the best tool for the job."}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 2xl:grid-cols-8 gap-4">
          {integrations?.map((int) => {
            const statusLabel =
              int?.statusKey === 'active' ? (ig?.statusActive ?? 'Active') :
              int?.statusKey === 'comingSoon' ? (ig?.statusComingSoon ?? 'Coming Soon') :
              (ig?.statusPlanned ?? 'Planned');
            const statusClass =
              int?.statusKey === 'active' ? 'bg-mint/15 text-mint' :
              int?.statusKey === 'comingSoon'? 'bg-accent/15 text-accent' : 'bg-muted text-muted-foreground';
            return (
              <div key={int?.id} className="glass-card glass-card-hover rounded-xl p-4 flex flex-col items-center text-center gap-2">
                <div className={`w-10 h-10 rounded-lg ${int?.bg} flex items-center justify-center text-lg font-800 ${int?.color}`}>
                  {int?.name?.charAt(0)}
                </div>
                <p className="text-xs font-600 text-foreground leading-tight">{int?.name}</p>
                <p className="text-[10px] text-muted-foreground">{int?.label}</p>
                <span className={`text-[9px] font-600 px-1.5 py-0.5 rounded-full ${statusClass}`}>
                  {statusLabel}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}